﻿import { customElement } from 'lit/decorators.js';
import { AtlGridColProps, AtlGridTagNames } from './grid.props';
import { getGlobalStyleSheets } from '../../global-styles';
import {
   AlignItems,
   AlignItemsValuesMap,
   Breakpoint,
   BreakpointValuesMap,
   enumAttributeConverter,
} from '../enum-types';
import { JustifyContent, JustifyContentValues } from '../justify-content';
import { ClassComponent } from '../ClassElement';

@customElement(AtlGridTagNames.GridCol)
export class AtlGridCol extends ClassComponent implements AtlGridColProps {
   declare asFlex: boolean;
   declare autoSizing: boolean;
   declare colSize: number;
   declare alignItems?: AlignItems;
   declare justifyContent?: JustifyContent;
   declare breakpoint?: Breakpoint;

   static properties = {
      asFlex: { type: Boolean, attribute: 'as-flex' },
      autoSizing: { type: Boolean, attribute: 'auto-sizing' },
      colSize: { type: Number, attribute: 'col-size' },
      alignItems: {
         type: String,
         attribute: 'align-items',
         converter: enumAttributeConverter(AlignItems),
      },
      justifyContent: {
         type: String,
         attribute: 'justify-content',
         converter: enumAttributeConverter(JustifyContent),
      },
      breakpoint: {
         type: String,
         converter: enumAttributeConverter(Breakpoint, Breakpoint.Large),
      },
   };

   static styles = [...getGlobalStyleSheets()];

   get _classesStartingWith(): string[] {
      return ['col-', 'align-items-', 'justify-content-'];
   }

   get _classesContaining(): string[] {
      return ['grid-col', 'd-flex'];
   }

   _buildClassList(classList: string[]): void {
      classList.push('grid-col');
      classList.push(this.columnClassName);

      if (this.asFlex) {
         classList.push('d-flex');
      }

      if (this.alignItems) {
         classList.push(AlignItemsValuesMap[this.alignItems]);
      }

      if (this.justifyContent) {
         classList.push(JustifyContentValues[this.justifyContent]);
      }
   }

   get columnClassName() {
      if (this.autoSizing) {
         return 'col-auto';
      }

      const breakpointClassName = `col-${BreakpointValuesMap[this.breakpoint || Breakpoint.Medium]}`;
      return this.colSize
         ? `${breakpointClassName}-${this.colSize}`
         : breakpointClassName;
   }
}
